<template>
  <div styleName="content_speaker_wp">
    <div styleName="content_speaker">
      <div styleName="content_speaker_left">
        <template v-if="roomDetail.data.roomRole === 2">
          <label>{{ $t('selectSpeaker') }}</label>
          <select :value="changedAudioOutputDeviceIndex" :disable="selectDisabled" @change="changeAudioOutputDevice">
            <option v-for="(device, index) in audioOutputList" :value="index" :key="device.deviceId">
              {{device.label || $t('speaker') + ' ' + (index + 1)}}
            </option>
          </select>
        </template>
        <template>
          <label>{{ $t('clickToAudition') }}</label>
          <button @click="initPlay">{{ $t('BeginAudition') }}</button>
        </template>
        <!--<label v-else>{{ $t('voiceFileLoading') }}</label>-->
        <canvas id="visualizer" width="286" height="32"></canvas>
      </div>
      <div styleName="content_speaker_right" :data-lang="$i18n.locale">
        <h4>
          <i styleName="content_speaker_icon"></i>{{ $t('noVoice') }}</h4>
        <p v-for="(problem, index) in $t('voiceProblems')" :key="problem">{{ index + 1 }}. {{ problem }}</p>
      </div>
    </div>
    <div styleName="content_footer">
      <button @click="_confirm" data-role="active">{{ $t('confirm') }}</button>
    </div>
  </div>
</template>

<script>
import styles from './index.scss'
import cssModules from 'vue-css-modules'
import { mapGetters } from 'vuex'
import concert from '@/assets/media/concert-crowd.ogg'
import storage from '@/utils/operateStorage'
import sensorLog from '@/utils/sensorLog'
import * as types from '../../constants'

export default {
  name: 'speaker',
  mixins: [cssModules(styles)],
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      audioCtx: null, // 音频处理上下文
      buffer: null, // 解码音频后的缓冲数据流
      audioBufferSourceNode: null, // 音频源缓冲节点
      first: true,
      changingAudioOutputDevice: false,
      tempAudioOutputIndex: 0,
      stream: null
    }
  },
  computed: {
    ...mapGetters(['alertStatus', 'deviceLists', 'roomDetail']),
    audioOutputList () {
      return this.deviceLists.audioOutputList
    },
    currentDeviceId () {
      return this.audioOutputList &&
        this.audioOutputList[this.changedAudioOutputDeviceIndex] &&
        this.audioOutputList[this.changedAudioOutputDeviceIndex].deviceId || ''
    },
    // 默认扬声器
    selectedAudioOutputDeviceIndex () {
      let deviceCount = this.audioOutputList.length
      let isValid = this.$store.state.mediaInfo.selectedAudioOutputDevice <= deviceCount - 1
      return isValid ? this.$store.state.mediaInfo.selectedAudioOutputDevice : 0
    },
    // 更改后的音频设备
    changedAudioOutputDeviceIndex () {
      return this.changingAudioOutputDevice ? this.tempAudioOutputIndex : this.selectedAudioOutputDeviceIndex
    },
    selectDisabled () {
      return !('sinkId' in HTMLMediaElement.prototype)
    }
  },
  watch: {
    alertStatus (newVal) {
      if (newVal) return
      this._resume()
      this.changingAudioOutputDevice = false
    },
    show (flag) {
      if (flag) return
      this._resume()
      this.changingAudioOutputDevice = false
    }
  },
  destroyed () {
    this._resume();
  },
  methods: {
    initPlay (e) {
      if (this.buffer) {
        this.play(e)
      } else {
        this.createAudioCtx()
        this.getAudio().then(() => this.play(e))
      }
    },
    createAudioCtx () {
      let AudioContext = window.AudioContext || window.webkitAudioContext
      this.audioCtx = new AudioContext()
    },
    getAudio () {
      return new Promise((resolve, reject) => {
        let self = this
        let ajaxReq = new XMLHttpRequest()
        ajaxReq.open('GET', concert, true)
        ajaxReq.responseType = 'arraybuffer' // 配置数据返回类型
        ajaxReq.onload = function () {
          let audioData = ajaxReq.response // 获取到音频文件的音频数据对象
          self.audioCtx && self.audioCtx.decodeAudioData(audioData, function (buffer) { // 解码数据
            self.buffer = buffer
            resolve()
          }, function (e) {
            reject(e)
          })
        }
        ajaxReq.send()
      })
    },
    // 可视化展示之前的音频处理操作
    play (e) {
      if (this.first) {
        this.first = false
        let audioContext = this.audioCtx
        let buffer = this.buffer
        if (audioContext === null || buffer === null) return
        let audioBufferSourceNode = this.audioBufferSourceNode = audioContext.createBufferSource()
        let analyzer = audioContext.createAnalyser() // 创建获取频谱能量值的analyzer节点
        let dest = audioContext.createMediaStreamDestination()
        analyzer.minDecibels = -90 // 设置分贝
        analyzer.maxDecibels = 120
        analyzer.smoothingTimeConstant = 0.85
        audioBufferSourceNode.connect(analyzer) // 音频节点连接到分析器
        analyzer.connect(dest)
        this.stream = dest.stream
        this.attachSinkId()
        // analyzer.connect(audioContext.destination) // 分析器输出到扬声器
        audioBufferSourceNode.buffer = buffer
        audioBufferSourceNode.start(0)
        this._drawSpectrum(analyzer)
        this.audioElem = e.target
        e.target.style.cursor = 'not-allowed'
        let timer = this.timer = setTimeout(() => {
          e.target.style.cursor = 'pointer'
          this.first = true
          clearTimeout(timer)
        }, buffer.duration * 1000)
      }
    },
    _drawSpectrum (analyser) {
      let canvas = document.getElementById('visualizer')
      let ctx = canvas.getContext('2d')
      const WIDTH = canvas.width
      const HEIGHT = canvas.height
      analyser.fftSize = 256
      let bufferLengthAlt = analyser.frequencyBinCount
      console.log('frequencyBinCount', bufferLengthAlt)
      let dataArrayAlt = new Uint8Array(bufferLengthAlt)

      let barWidth = 6
      let gap = 1
      let meterNum = WIDTH / (barWidth + gap)
      let step = Math.round(dataArrayAlt.length / meterNum)
      console.log('step', step)

      ctx.clearRect(0, 0, WIDTH, HEIGHT)

      let drawAlt = function () {
        requestAnimationFrame(drawAlt)
        analyser.getByteFrequencyData(dataArrayAlt)

        ctx.fillStyle = 'rgb(255, 255, 255)'
        ctx.fillRect(0, 0, WIDTH, HEIGHT)

        // let barWidth = (WIDTH / bufferLengthAlt) * 2.5
        let barHeight
        // let x = 0

        for (let i = 0; i < meterNum; i++) {
          barHeight = dataArrayAlt[i * step]

          let gradient = ctx.createLinearGradient(0, 0, 0, 300);
          gradient.addColorStop(1, 'rgb(20,186,94)');
          gradient.addColorStop(0, 'rgb(0,153,68)');
          ctx.fillStyle = gradient;
          ctx.fillRect(i * (barWidth + gap), HEIGHT - barHeight / 3, barWidth, barHeight / 3)
          // x += barWidth + 1
        }
      }
      drawAlt()
    },
    changeAudioOutputDevice (e) {
      console.log('setting current audio output device id: ', e.target.value)
      this.changingAudioOutputDevice = true
      this.tempAudioOutputIndex = +e.target.value
      this.attachSinkId()
    },
    async attachSinkId () {
      if (this.audio) {
        await this.audio.pause()
        delete this.audio
      }
      this.audio = new Audio()
      this.audio.srcObject = this.stream
      this.audio.play()
      console.log(`setting audio output device attaching: ${this.currentDeviceId}`)
      if (this.audio && this.currentDeviceId && typeof this.audio.setSinkId === 'function') {
        this.audio.setSinkId(this.currentDeviceId)
          .then(() => {
            sensorLog.track("hardware_speaker_attach", types.SENSORLOG.type.SUCCESSED, JSON.stringify({ deviceId: this.currentDeviceId }))

          }).catch(error => {
            let errorMessage = error
            if (error.name === 'SecurityError') {
              errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`
            }
            sensorLog.track("hardware_speaker_attach", types.SENSORLOG.type.FAILED, errorMessage)
          })
      }
    },
    _resume () {
      if (this.audioBufferSourceNode) {
        this.audioBufferSourceNode.stop()
        this.audioBufferSourceNode.buffer = null
      }
      if (this.audioElem) {
        this.audioElem.style.cursor = 'pointer'
      }
      this.first = true
      clearTimeout(this.timer)
    },
    _confirm () {
      this._resume()
      console.log('setting selected audio output device id: ', this.changedAudioOutputDeviceIndex)
      this.$store.commit('CHANGE_AUDIO_OUTPUT_DEVICE', this.changedAudioOutputDeviceIndex)
      this.changingAudioOutputDevice = false
      this.$store.commit(types.ALERT_STATUS, false)
      storage.set('AUDIO_OUTPUT_DEVICE', this.changedAudioOutputDeviceIndex) // 将当前选择扬声器deviceId存入本地localStorage

    }
  }
}
</script>
